/* ============================================================
   Aurelys — Gotas de Drenaje Linfático (slug 'aurelys').
   Cargado por layout/landing.liquid (case 'aurelys').
   Bloques: galería de thumbnails · selección de bundle (.nx-bundle) ·
   disparo del modal Releasit COD.
   Patrón Releasit (per-unit + quantity): cada bundle = 1 variante con precio
   POR UNIDAD; mandamos quantity = N (unidades) para que el pedido lleve las
   unidades reales (Dropi) y el total quede en el precio del bundle. Releasit
   lee input[name="quantity"] del DOM al disparar. NO usar _rsiV2.setState como
   primer path — el click nativo del botón Releasit SÍ re-lee productData.
   Ver memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- Galería buy-box: thumb cambia principal ---------- */
function nxGal(i) {
  var thumbs = document.querySelectorAll('.nx-thumbs .nx-slot');
  thumbs.forEach(function (t, n) { t.classList.toggle('active', n === i); });
  var img = thumbs[i] && thumbs[i].querySelector('img');
  var main = document.getElementById('nx-main');
  if (img && img.getAttribute('src') && main) main.src = img.getAttribute('src');
}
window.nxGal = nxGal;

/* ============================================================
   Releasit COD trigger + selección de bundle
   ============================================================ */
var AURELYS_RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];

function aurelysFindReleasitButton() {
  for (var i = 0; i < AURELYS_RELEASIT_SELECTORS.length; i++) {
    var el = document.querySelector(AURELYS_RELEASIT_SELECTORS[i]);
    if (el) return el;
  }
  return null;
}

var aurelysSelectedVariantId = null;
var aurelysSelectedQty = 1;

// Cada bundle = una variante con precio POR UNIDAD; mandamos la cantidad real
// (1/2/3 frascos) para que el pedido llegue con las unidades exactas (Dropi
// envía la cantidad) y el total quede en el precio del bundle. Releasit lee el
// input[name="quantity"] del DOM al disparar COD.
function aurelysSetVariantOnAllForms(variantId, qty) {
  if (!variantId) return;
  var q = parseInt(qty, 10);
  if (!q || q < 1) q = 1;
  document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = String(q);
    input.setAttribute('value', String(q));
  });
  if (window.productData) { window.productData.quantity = q; }
  if (window.productData && Array.isArray(window.productData.variants)) {
    var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (v) {
      window.productData.selected_or_first_available_variant = v;
      window.productData.selected_variant = v;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
      } catch (e) {}
    }
  }
}

function aurelysBundleQty(el) {
  var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
  if (!q) { q = parseInt(el.getAttribute('data-units'), 10); }
  return q || 1;
}

/* ---------- Selección de bundle ---------- */
var nxBundles = document.querySelectorAll('.nx-bundle');

function nxBundle(el) {
  nxBundles.forEach(function (x) { x.classList.remove('sel'); });
  el.classList.add('sel');
  var id = el.getAttribute('data-bundle-variant-id');
  if (id) {
    aurelysSelectedVariantId = id;
    aurelysSelectedQty = aurelysBundleQty(el);
    aurelysSetVariantOnAllForms(id, aurelysSelectedQty);
  }
}
window.nxBundle = nxBundle;

function aurelysTriggerCOD(btn) {
  var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || aurelysSelectedVariantId;
  var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || aurelysSelectedQty;
  if (variantId) aurelysSetVariantOnAllForms(variantId, qty);
  setTimeout(function () {
    var releasitBtn = aurelysFindReleasitButton();
    if (releasitBtn) { releasitBtn.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = aurelysFindReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }, 50);
}
window.aurelysTriggerCOD = aurelysTriggerCOD;

/* ---------- Init: bundle preseleccionado (.sel o el primero) ---------- */
(function () {
  var active = document.querySelector('.nx-bundle.sel') || document.querySelector('.nx-bundle');
  if (active) nxBundle(active);
})();
